import React, { Component } from 'react';
import { Container, Col, Row } from 'reactstrap';
import API from '../API';
import { Apify } from '../Apify';
import NotificationsService from '../NotificationsService';
import Notification from '../c/Notification';
import XTab from '../c/XTab';
import { T } from '../traks';

class Notifications extends Component {
	constructor(props) {
		super(props);
		this.state = {notifications: null};
		this.see_timeout_id = undefined;
		this.see_xhr = undefined;
		this.seen_id = 0;
	}

	schedule_see_action(id) {
		this.seen_id = Math.max(this.seen_id, id);
		if (this.see_timeout_id !== undefined) clearTimeout(this.see_timeout_id);
		this.see_timeout_id = setTimeout(() => {
			this.see_xhr = API.post("/a/seen_notification", {id: this.seen_id}, () => {
				this.see_xhr = undefined;
				NotificationsService.ping();
			});
		}, 1000);
	}

	componentWillUnmount() {
		if (this.see_timeout_id !== undefined) {
			clearTimeout(this.see_timeout_id);
			this.see_timeout_id = undefined;
		}
		if (this.see_xhr !== undefined) {
			this.see_xhr.abort();
			this.see_xhr = undefined;
		}
	}

	render() {
		if (this.props.notifications.length === 0) {
			return (
				<Container>
					<h2 className="pt-4 pb-0 mb-0"><T>Notifications</T></h2>
					<div className="mt-0 pt-0 pb-4"><T>(Note: notifications will be deleted after 30 days, or when they exceed 100)</T></div>
					<Row className="ad_pb-10">
						<Col className="pb-5" md="12">
							<div className="ad_notification_box py-2 px-4">
								<div className="ad_notification_header"><T>You have no notifications.</T></div>
							</div>
						</Col>
					</Row>
				</Container>
			);
		}
		var unread = [];
		var read = [];

		for (const n of this.props.notifications) {
			this.schedule_see_action(n.Id);
			if(n.IsNew) {
				unread.push(<Notification key={n.Id} notification={n}/>);
			} else {
				read.push(<Notification key={n.Id} notification={n}/>);
			}
		}

		const n_unread = unread.length;
		const unread_tab = [<span><T>New messages ({n_unread})</T></span>];

		const n_read = read.length;
		const archive_tab = [<span><T>Archive ({n_read})</T></span>];

		var new_seperator = null;
		var read_seperator = null;

		if(unread.length) {
			new_seperator = <XTab tabs={unread_tab}/>;
		}

		if(read.length) {
			read_seperator = <XTab tabs={archive_tab}/>;
		}

		return (
			<Container className='pb-4'>
				<h2 className="pt-4 pb-0 mb-0"><T>Notifications</T></h2>
				<div className="mt-0 pt-0 pb-4"><T>(Note: notifications will be deleted after 30 days, or when they exceed 100)</T></div>
				<div>
				<Row className='ad_black_wrapper'>
					<Col md="12">
						<div>{new_seperator}</div>
						<div>{unread}</div>
						<div>{read_seperator}</div>
						<div>{read}</div>
					</Col>
				</Row>
				</div>
			</Container>
		);
	}
}

Notifications = Apify("/a/notifications")
	.with_response_prop("notifications")
	.wrap(Notifications);

export default Notifications;



// WEBPACK FOOTER //
// ./src/p/Notifications.js